var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDocsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2196f3",
  d: "M37 45H11a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h19l10 10v29a3 3 0 0 1-3 3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#bbdefb",
  d: "M40 13H30V3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1565c0",
  d: "m30 13 10 10V13z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e3f2fd",
  d: "M15 23h18v2H15zm0 4h18v2H15zm0 4h18v2H15zm0 4h10v2H15z"
})));
export { SvgGoogleDocsIcon as ReactComponent };
export default __webpack_public_path__ + "52ee8d5f48fb8bfa9ac238d0e7c25678.svg";